import { lazy } from "react";

export const LazyDemoDataPage = lazy(
    () => import(/* webpackChunkName: "DemoDataPage" */ "./DemoDataPage")
);
